import { useDispatch, useSelector } from "react-redux";

import type { AppDispatch, RootState } from "@/app/store";

import { clearError, clearResendError, clearVerifyError, reset } from "../store/registerSlice";
import {
  thunkChangeVerificationEmail,
  thunkRegister,
  thunkResendVerificationCode,
  thunkVerifyEmail,
} from "../store/registerThunks";
import type { RegisterRequestDto, VerifyEmailRequestDto } from "../types/register.types";

export function useRegister() {
  const dispatch = useDispatch<AppDispatch>();

  const isLoading = useSelector((s: RootState) => s.register.isLoading);
  const error = useSelector((s: RootState) => s.register.error);
  const emailConflict = useSelector((s: RootState) => s.register.emailConflict);
  const success = useSelector((s: RootState) => s.register.success);

  const isVerifying = useSelector((s: RootState) => s.register.isVerifying);
  const verifyError = useSelector((s: RootState) => s.register.verifyError);
  const verified = useSelector((s: RootState) => s.register.verified);

  const isResending = useSelector((s: RootState) => s.register.isResending);
  const resendError = useSelector((s: RootState) => s.register.resendError);
  const lastResendAt = useSelector((s: RootState) => s.register.lastResendAt);

  const isChangingEmail = useSelector((s: RootState) => s.register.isChangingEmail);

  return {
    // Register
    isLoading,
    error,
    emailConflict,
    success,
    doRegister: (body: RegisterRequestDto, turnstileToken?: string | null) =>
      dispatch(thunkRegister(body, turnstileToken)),
    clearError: () => dispatch(clearError()),
    reset: () => dispatch(reset()),

    // Verify
    isVerifying,
    verifyError,
    verified,
    doVerifyEmail: (body: VerifyEmailRequestDto) => dispatch(thunkVerifyEmail(body)),
    clearVerifyError: () => dispatch(clearVerifyError()),

    // Resend
    isResending,
    resendError,
    lastResendAt,
    doResendVerificationCode: (email: string) => dispatch(thunkResendVerificationCode({ email })),
    clearResendError: () => dispatch(clearResendError()),

    // Correct the address
    isChangingEmail,
    doChangeVerificationEmail: (email: string) => dispatch(thunkChangeVerificationEmail({ email })),
  };
}
